import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"
import { showOverlay, hideOverlay, scrollToFirstError, buildValidationFormData } from '../services/form_helper'

export default class extends mdkController {
  static targets = ['form', 'generalError'];
  static classes = ['errorm','readonly'];
  static values = {validateurl: String, validateflag: String, networkErrorMessage: String};

  formTargetConnected(){
    const corpMailType = this.formTarget.querySelector("input[name='user[email_type]']");
    if (corpMailType != undefined){
      this.readonlyUserEmail(corpMailType);
    }
    // YAS-31: iOS WebKit 空body対策のメモリ化（旧 rematerializeFileInput）は
    // components--preview#display（components/_insurance_card）へ一本化した。
    // 会員登録フォームの file input は全て同 partial 由来（動的追加の input は無い）ため、
    // capture リスナを廃止してもカバー範囲は縮まらない。二重の arrayBuffer() を避けるための集約。
  }

  // 検証AJAX用のFormDataを構築する（実体は services/form_helper.js の共通関数）。
  buildValidationFormData(){
    return buildValidationFormData(this.formTarget);
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = this.buildValidationFormData();
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(onSuccessCallback, onErrorCallback, attempt = 1){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = this.buildValidationFormData();
    // 観測用: 送信直前のFormData実体をクエリ文字列で申告する（bodyが消失しても届くため、
    // サーバ側の空body warning と突き合わせて原因を切り分けられる）
    let fdCount = 0, fdBytes = 0;
    for (const [, v] of formData.entries()) {
      fdCount++;
      fdBytes += (v instanceof File) ? v.size : String(v).length;
    }
    const debugUrl = this.validateurlValue + (this.validateurlValue.includes('?') ? '&' : '?') +
      `_fd_count=${fdCount}&_fd_bytes=${fdBytes}`;
    const flag = document.getElementById(this.validateflagValue);
    Rails.ajax({
      url: debugUrl,
      type: "POST",
      dataType: 'json',
      data: formData,
      error: (response)=> {
        // 空body等の一過性の送信失敗は、接続を張り直した再送でほぼ成功するため1回だけ自動リトライする
        if(attempt < 2){
          setTimeout(()=> this.validateAll(onSuccessCallback, onErrorCallback, attempt + 1), 500);
          return;
        }
        flag.value = 'false';
        this.showGeneralError(response);
        if(typeof onErrorCallback == 'function'){
          onErrorCallback();
        }
      },
      success: (response)=> {
        this.clearGeneralError();
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
          flag.value = 'false';
          if(typeof onErrorCallback == 'function'){
            onErrorCallback();
          }
        }else{
          flag.value = 'true';
          if(typeof onSuccessCallback == 'function'){
            onSuccessCallback();
          }
        }
      }
    });
  }

  showGeneralError(response){
    if(!this.hasGeneralErrorTarget){ return; }
    const message = (response && response.error) || this.networkErrorMessageValue;
    this.generalErrorTarget.innerHTML = message;
  }

  clearGeneralError(){
    if(!this.hasGeneralErrorTarget){ return; }
    this.generalErrorTarget.innerHTML = '';
  }

  onSubmit(){
    const flag = document.getElementById(this.validateflagValue);
    if(flag.value == 'true'){
      this.formTarget.submit();
    }
  }

  validateAndSubmit(event){
    const el = event.currentTarget;
    const target = this.formTarget;
    showOverlay();
    this.validateAll(function(){
      el.disabled = true;
      target.submit();
    }, function(){
      hideOverlay();
      scrollToFirstError('error-message');
    })
  }
  validateAndRegisterAndSubmit(event) {
    const el = event.currentTarget;
    const _this = this
    showOverlay();
    this.validateAll(function () {
        _this.register(function () {
          el.disabled = true;
          _this.formTarget.submit();
        })
      }, function(){
        hideOverlay();
        scrollToFirstError('error-message');
      }
    )
  }

  corpMail(e){
    const el = e.currentTarget;
    this.readonlyUserEmail(el);
  }
  readonlyUserEmail(el){
    const userMail = this.formTarget.querySelector("#user_email");
    if(el.value == "1"){
      userMail.classList.add(this.readonlyClass);
      userMail.readOnly = true;
    }else{
      userMail.classList.remove(this.readonlyClass);
      userMail.readOnly = false;
    }
  }
}
